import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericService } from '../../generic.service';
import { Router, RouterModule } from '@angular/router';
import { PopUpComponent } from '../pop-up/pop-up.component';
import { HeaderComponent } from '../../shared/header/header.component';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { LandingService } from '../../landing-page/service/landing.service';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-poor-results-eht',
    imports: [CommonModule, RouterModule, PopUpComponent, HeaderComponent],
    templateUrl: './poor-results-eht.component.html',
    styleUrl: './poor-results-eht.component.scss'
})
export class PoorResultsEhtComponent {
  deviceData: any = {};
  deviceData$: any = null;

  issueName: string | undefined;
  accountNumber: string = '';
  popupImages: string[] = [];
  showPopup: boolean = false;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  issueList = [
    {
      titleKey: 'poorResults.eht.title.detergentIssue',
      detailsKey: 'poorResults.eht.details.detergentIssue',
      answered: false,
      status: '',
      expanded: false,
      images: [],
      video: '',
    },
    {
      titleKey: 'poorResults.eht.title.waterHeater',
      detailsKey: '',
      answered: false,
      status: '',
      expanded: false,
      images: [],
      video: '',
    },
    {
      titleKey: 'poorResults.eht.title.waterOn',
      detailsKey: '',
      answered: false,
      status: '',
      expanded: false,
      images: [],
      video: '',
    },
    {
      titleKey: 'poorResults.eht.title.endCap',
      detailsKey: 'poorResults.eht.details.endCap',
      answered: false,
      status: '',
      expanded: false,
      images: ['assets/images/troubleshooting/eht/eht-spray-end-cap.gif'],
      video: '',
    },
    {
      titleKey: 'poorResults.eht.title.armSpin',
      detailsKey: 'poorResults.eht.details.armSpin',
      answered: false,
      status: '',
      expanded: false,
      images: ['assets/images/troubleshooting/eht/eht-spray-arm-spins.gif'],
      video: '',
    },
    {
      titleKey: 'poorResults.eht.title.noDebrisArm',
      detailsKey: 'poorResults.eht.details.noDebrisArm',
      answered: false,
      status: '',
      expanded: false,
      images: [
        'assets/images/troubleshooting/eht/eht-spray-nozzle-1.png',
        'assets/images/troubleshooting/eht/eht-spray-nozzle-2.gif',
      ],
      video: '',
    },
    {
      titleKey: 'poorResults.eht.title.noLimescale',
      detailsKey: 'poorResults.eht.details.noLimescale',
      answered: false,
      status: '',
      expanded: false,
      images: [],
      video: '',
    },
    {
      titleKey: 'poorResults.eht.title.softner',
      detailsKey: 'poorResults.eht.details.softner',
      answered: false,
      status: '',
      expanded: false,
      images: [],
      video: '',
    },
  ];

  constructor(
    private router: Router,
    private genericService: GenericService,
    private crowdinService: CrowdinService,
    private landingService: LandingService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();
    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  get progress() {
    const answered = this.issueList.filter((item) => item.answered).length;
    return (answered / this.issueList.length) * 100;
  }

  answer(index: number, status: string) {
    this.issueList[index].status = status;
    this.issueList[index].answered = true;
    if (this.issueList[index].detailsKey) {
      this.issueList[index].expanded = true;
    }
  }

  toggleAccordion(index: number) {
    this.issueList[index].expanded = !this.issueList[index].expanded;
  }

  resolved() {
    this.router.navigateByUrl('thankYou');
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
  }

  needHelp() {
    this.deviceData['issueName'] = this.issueName;
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    this.landingService.needHelp();
  }

  getTranslatedTitle(item: any): string {
    return this.translations?.[item.titleKey] ?? item.titleKey;
  }

  getTranslatedDetails(item: any): string {
    return this.translations?.[item.detailsKey] ?? item.detailsKey;
  }

  openPopup(images: string[], title?: string) {
    this.popupImages = images;
    this.showPopup = true;
  }

  closePopup() {
    this.showPopup = false;
  }
}
